import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CreateGrievanceService } from './create-grievance.service';
import { Router } from '@angular/router';
import { AttachmentErrorDialogComponent } from '../../attachment-error-dialog/attachment-error-dialog.component';
import { GrievanceExistDialogComponent } from '../../grievance-exist-dialog/grievance-exist-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { GrievanceDialogComponent } from '../../grievance-dialog/grievance-dialog.component';
import { OtpDialogComponent } from '../../otp-dialog/otp-dialog.component';
import { Board, GrievanceType } from '../../interface/common-interface';
import { FaqDialogComponent } from '../../faq-dialog/faq-dialog.component';
import { ProjectConstants } from '../../project-constants';
import { CommonFunction } from '../../common-function';

@Component({
  selector: 'app-create-grievance',
  templateUrl: './create-grievance.component.html',
  styleUrls: ['./create-grievance.component.scss'],
})

export class CreateGrievanceComponent implements OnInit {
  showFAQ: boolean = false;
  FaqLink: String;

  fileWarningMsg1=ProjectConstants.uiUploadMax3FilesMsg
  fileWarningMsg2=ProjectConstants.uiFileExtensionMsg
  fileWarningMsg3=ProjectConstants.uiFileSizeMsg

  protected boards: Board[] = [];
  public boardCtrl: FormControl = new FormControl();
  public boardFilterCtrl: FormControl = new FormControl();
  public filteredboards: ReplaySubject<Board[]> = new ReplaySubject<Board[]>(1);

  protected grievance: GrievanceType[] = [];
  public grievanceCtrl: FormControl = new FormControl();
  public grievanceFilterCtrl: FormControl = new FormControl();
  public filteredGrievance: ReplaySubject<GrievanceType[]> = new ReplaySubject<GrievanceType[]>(1);
  protected _onDestroy = new Subject<void>();

  @ViewChild('attachments') attachments: any;
  @ViewChild('attachments1') attachments1: any;
  @ViewChild('attachments2') attachments2: any;

  isShowClose: boolean = false;
  isShowClose1: boolean = false;
  isShowClose2: boolean = false;

  filefirst: boolean = false;
  fileSecond: boolean = false;
  filethird: boolean = false;
  file: File = null;
  file1: File = null;
  file2: File = null;
  filenm: any;
  filenm1: any;
  filenm2: any;
  fileObj: any;
  grievanceTypeId: any
  isSubmitDisabled: boolean = false;
  firstFormGroup = this._formBuilder.group({
    boardCtrl: ['', [Validators.required]],
    grievanceCtrl: ['', [Validators.required]],
    subjectCtrl: ['', [Validators.required]],
    remarkCtrl: ['', [Validators.required]]
  })
  progressSpinnerDialog: any = null;
  fileBase64: any;
  fileBase1_64: any;
  fileBase2_64: any;

  constructor(public _formBuilder: FormBuilder,
    public dialog: MatDialog,
    public router: Router,
    public commonFunction: CommonFunction,
    public createService: CreateGrievanceService,
  ) { }

  //progress bar
  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }
  //

  ngOnInit() {
    this.showFile()
    this.loadBoards()
  }


  //load boards
  async loadBoards() {
    this.displayProgressSpinner();
    const response: any = await this.createService.loadBoard();
    this.progressSpinnerDialog.close();
    if (response != null && !response.error) {
      if (response.length != 0) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          this.boards = response
          this.boardCtrl.setValue(this.boards[10]);
          this.filteredboards.next(this.boards);
          this.boardFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
              this.filterboards();
            });
        } else if (response[0].status == ProjectConstants.responseStatusFailure) {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        this.boards = []
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }
  //


  //show upload file 1 or 2 or 3
  showFile() {
    if (this.file == null && this.file1 == null && this.file2 == null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 == null && this.file2 != null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 != null && this.file2 == null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 != null && this.file2 != null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 == null && this.file2 == null) {
      this.filefirst = false;
      this.fileSecond = true;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 == null && this.file2 != null) {
      this.filefirst = false;
      this.fileSecond = true;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 != null && this.file2 == null) {
      this.filefirst = false;
      this.fileSecond = false;
      this.filethird = true;
    }
    else if (this.file != null && this.file1 != null && this.file2 != null) {
      this.filefirst = false;
      this.fileSecond = false;
      this.filethird = false;
    }
  }
  //


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  // select board dependant on grievance type
  async selectBoard(boardId: any) {
    this.showFAQ = false;
    this.displayProgressSpinner();
    const response: any = await this.createService.loadGrievance(boardId);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.length != 0) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          this.grievance = response;
          this.grievanceCtrl.setValue(this.grievance[10]);
          this.filteredGrievance.next(this.grievance.slice());
          this.grievanceFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
              this
                .filtereGrievances();
            })
        }
        else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        this.grievance = []
        this.grievanceCtrl.setValue(this.grievance[10]);
        this.filteredGrievance.next(this.grievance.slice());
        this.grievanceFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtereGrievances();
          })
        await this.commonFunction.errorToast(ProjectConstants.noGtypeFound, false, "")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }
  //

  // filter boards
  protected filterboards() {
    if (!this.boards) {
      return;
    }
    let search = this.boardFilterCtrl.value;
    if (!search) {
      this.filteredboards.next(this.boards.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredboards.next(this.boards.filter(
      item => item.boardName.toLowerCase().indexOf(search) > -1)
    )
  }
  //

  //grievance type filter
  protected filtereGrievances() {
    if (!this.grievance) {
      return;
    }
    let search = this.grievanceFilterCtrl.value;
    if (!search) {
      this.filteredGrievance.next(this.grievance.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredGrievance.next(
      this.grievance.filter(grievance => grievance.gtGrievanceType.toLowerCase().indexOf(search) > -1)
    );
  }
  //

  // remove upload
  removeAttachment() {
    if (this.file1 != null) {
      this.file = this.file1
      this.filenm = this.filenm1
      this.fileBase64 = this.fileBase1_64
      if (this.file2 != null) {
        this.file1 = this.file2
        this.filenm1 = this.filenm2
        this.fileBase1_64 = this.fileBase2_64
        this.isShowClose2 = false;
        this.file2 = null
        this.fileBase2_64 = null
        this.filenm2 = null
      } else {
        this.attachments.nativeElement.value = '';
        this.file1 = null
        this.fileBase1_64 = null
        this.filenm1 = null
        this.isShowClose1 = false;
      }
    } else {
      this.attachments.nativeElement.value = '';
      this.file = null
      this.fileBase64 = null
      this.filenm = null
      this.isShowClose = false;
    }
    this.showFile()
  }
  //

  // remove upload
  removeAttachment1() {
    if (this.file2 != null) {
      this.file1 = this.file2
      this.file2 = null
      this.fileBase1_64 = this.fileBase2_64
      this.fileBase2_64 = null
      this.filenm1 = this.filenm2
      this.filenm2 = null
      this.isShowClose2 = false;
    } else {
      this.attachments1.nativeElement.value = '';
      this.isShowClose1 = false;
      this.file1 = null
      this.filenm1 = null
      this.fileBase1_64 = null
    }
    this.showFile()
  }
  //

  // remove upload
  removeAttachment2() {
    this.attachments2.nativeElement.value = '';
    this.isShowClose2 = false;
    this.file2 = null
    this.filenm2 = null
    this.fileBase2_64 = null
    this.showFile()
  }
  //

  //file upload 1
  onChange(event) {
    this.file = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    var reader = new FileReader();
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':
        if (size <= ProjectConstants.maxFileSize) {
          if (this.file == null) {
            this.isShowClose = false;
            this.filenm = ""
          } else {
            this.filenm = this.file.name
            this.isShowClose = true;
            this.showFile()
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(this.file);
          }
        } else {
          this.file = null
          this.filenm = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue},
          });
          event.target.value = "";
          this.showFile()
        }
        break;
      default:
        this.file = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse},
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.filenm == null) {
            this.isShowClose = false;
          } else {
            this.isShowClose = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(this.file);
          }
        });
    }
  }
  //

  //file upload 2
  onChange1(event) {
    this.file1 = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':
        if (size <= ProjectConstants.maxFileSize) {
          if (this.file1 == null) {
            this.isShowClose1 = false;
            this.filenm1 = ""
          } else {
            this.filenm1 = this.file1.name
            this.isShowClose1 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded1.bind(this);
            reader.readAsBinaryString(this.file1);
          }
        } else {
          this.file1 = null;
          this.isShowClose1 = false;
          this.filenm1 = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue},
          });
          event.target.value = "";
        }
        break;
      default:
        this.file1 = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize:ProjectConstants.isSizeCheckfalse},
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file1 == null) {
            this.isShowClose1 = false;
          } else {
            this.isShowClose1 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded1.bind(this);
            reader.readAsBinaryString(this.file1);
          }
        });
    }
  }
  //

  //file upload
  onChange2(event) {
    this.file2 = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':
        if (size <= ProjectConstants.maxFileSize) {
          if (this.file2 == null) {
            this.isShowClose2 = false;
            this.filenm2 = ""
          } else {
            this.filenm2 = this.file2.name
            this.isShowClose2 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded2.bind(this);
            reader.readAsBinaryString(this.file2);
          }
        } else {
          this.file2 = null;
          this.isShowClose2 = false;
          this.filenm2 = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue},
          });
          event.target.value = "";
        }
        break;
      default:
        this.file2 = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse},
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file2 == null) {
            this.isShowClose2 = false;
          } else {
            this.isShowClose2 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded2.bind(this);
            reader.readAsBinaryString(this.file2);
          }
        });
    }
  }

  //check grievance is duplicate or not 
  async submitForm(): Promise<void> {
    if (this.firstFormGroup.valid) {
      const checkDuplicateData = {
        gtId: this.firstFormGroup.controls['grievanceCtrl'].value,
      }
      this.displayProgressSpinner();
      const responseDuplicate: any = await this.createService.isCheckDeuplicate(checkDuplicateData)
      this.progressSpinnerDialog.close()
      if (responseDuplicate != null && !responseDuplicate.error) {
        if (responseDuplicate.status == ProjectConstants.responseStatusSuccess) {
          if (responseDuplicate.message == ProjectConstants.responseGriExist) {
            const dialogRef = this.dialog.open(GrievanceExistDialogComponent, {
              width: 'fit-content',
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe(async result => {
              var returnval = result;
              if (returnval == ProjectConstants.noMsg) {
                this.router.navigate(['secure/my-grievances'])
              } else {
                this.callRest()
              }
            });
          } else {
            this.callRest()
          }
        } else if (responseDuplicate.status == ProjectConstants.responseStatusFailure) {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        this.isSubmitDisabled = false
      }
    }
  }
  //

  //call raise grievance rest
  async callRest() {
    if (this.filenm != null) {
      var file1_extension = '.' + this.filenm.split('.')[this.filenm.split('.').length - 1]
    }
    if (this.filenm1 != null) {
      var file2_extension = '.' + this.filenm1.split('.')[this.filenm1.split('.').length - 1]
    }
    if (this.filenm2 != null) {
      var file3_extension = '.' + this.filenm2.split('.')[this.filenm2.split('.').length - 1]
    }

    const body = {
      fkBdid: this.firstFormGroup.controls['boardCtrl'].value,
      fkGtid: this.firstFormGroup.controls['grievanceCtrl'].value,
      usGriDetails: this.firstFormGroup.controls['remarkCtrl'].value,
      usGriSubject: this.firstFormGroup.controls['subjectCtrl'].value,
      file1: this.fileBase64,
      file1Ext: file1_extension,
      file2: this.fileBase1_64,
      file2Ext: file2_extension,
      file3: this.fileBase2_64,
      file3Ext: file3_extension,
      'file1Name': this.filenm,
      'file2Name': this.filenm1,
      'file3Name': this.filenm2

    }
    this.displayProgressSpinner();
    const response: any = await this.createService.submitGrievance(body);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        const dialogRef = this.dialog.open(OtpDialogComponent, {
          width: 'fit-content',
          disableClose: true,
          data: { id: response.pkUsgrid }
        });
        dialogRef.afterClosed().subscribe(async result => {
          if (result == ProjectConstants.yesMsg) {
            const dialogRef = this.dialog.open(GrievanceDialogComponent, {
              width: 'fit-content',
              disableClose: true,
              data: { id: response.pkUsgrid }
            });
            dialogRef.afterClosed().subscribe(result => {
              this.router.navigate(['secure/my-grievances'])
            });
          } else {
            this.router.navigate(['secure/my-grievances'])
          }
        });
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
    } else {
      this.isSubmitDisabled = false;
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }
  //

  //base 64 file 1
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase64 = btoa(binaryString);
  }
  //

  //base 64 file 2
  _handleReaderLoaded1(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase1_64 = btoa(binaryString);
  }
  //

  //base 64 file 3
  _handleReaderLoaded2(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase2_64 = btoa(binaryString);
  }
  //

  async getFaqLink(grievanceTypeId: any) {
    this.grievanceTypeId = grievanceTypeId
    const responce = await this.createService.loadFaqLink(grievanceTypeId)
    this.FaqLink = responce;
    this.showFAQ = true;
  }

  openWindow() {

    const dialogRef = this.dialog.open(FaqDialogComponent, {
      width: 'fit-content',
      // height:'50%',
      disableClose: false,
      data: { id: this.grievanceTypeId }
    });

  }

}

